export default "<full-calendar #calendar [options]=\"calendarOptions\"></full-calendar>\r\n";